export default __webpack_public_path__ + "static/evento_01-136f79b4a91e98435b3cbff8969e1705.jpg";